module.exports = "mutation AddUserVoucher($data:AddUserVoucherInput!){addUserVoucher(data:$data){success}}"